import React from "react";
import { Link } from "react-router-dom";

// ─────────────────────────────────────────────────────────────────────────────
// Competitive Examinations — hub page linking out to each exam-prep section.
// Same dark-gradient hub style as TnpscMenuPage.js / NeetPhysicsMenuPage.js,
// but with large icon tiles since this is the top-level entry point that the
// home page also links into.
// ─────────────────────────────────────────────────────────────────────────────
const EXAMS = [
  {
    icon: "🏛️",
    title: "TNPSC 554",
    subtitle: "Tamil Nadu Public Service Commission",
    desc: "Unit-wise concept guides and practice questions across all 10 units of the TNPSC 554 syllabus.",
    to: "/tnpsc",
    color: "#2563eb",
  },
  {
    icon: "🧪",
    title: "NEET Physics",
    subtitle: "National Eligibility cum Entrance Test",
    desc: "Chapter-wise concept guides and practice questions — the complete Class 11 & 12 Physics syllabus, 29 chapters.",
    to: "/neet-physics",
    color: "#16a34a",
  },
];

const S = {
  page: { minHeight: "100vh", background: "linear-gradient(135deg,#0f172a,#1a1a2e)", fontFamily: "'Segoe UI',sans-serif", color: "#e2e8f0", padding: "18px 16px 80px" },
  back: { color: "#94a3b8", fontSize: 13, textDecoration: "none" },
  grid: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))", gap: 20, maxWidth: 820, margin: "0 auto" },
};

function ExamTile({ exam }) {
  return (
    <Link
      to={exam.to}
      style={{
        display: "block",
        textDecoration: "none",
        background: "rgba(255,255,255,0.06)",
        border: `1px solid ${exam.color}66`,
        borderRadius: 20,
        padding: "36px 24px",
        textAlign: "center",
        transition: "transform 0.15s ease, background 0.15s ease",
      }}
      onMouseEnter={(e) => { e.currentTarget.style.background = "rgba(255,255,255,0.1)"; e.currentTarget.style.transform = "translateY(-3px)"; }}
      onMouseLeave={(e) => { e.currentTarget.style.background = "rgba(255,255,255,0.06)"; e.currentTarget.style.transform = "translateY(0)"; }}
    >
      <div
        style={{
          fontSize: 56,
          width: 110,
          height: 110,
          lineHeight: "110px",
          margin: "0 auto 18px",
          borderRadius: "50%",
          background: `${exam.color}26`,
          border: `2px solid ${exam.color}`,
        }}
      >
        {exam.icon}
      </div>
      <div style={{ fontWeight: 800, fontSize: 20, color: "#fff" }}>{exam.title}</div>
      <div style={{ fontSize: 12.5, fontWeight: 600, color: exam.color, marginTop: 4 }}>{exam.subtitle}</div>
      <div style={{ fontSize: 13, color: "#94a3b8", marginTop: 10, lineHeight: 1.6 }}>{exam.desc}</div>
      <div style={{ marginTop: 16, display: "inline-block", background: exam.color, color: "#fff", borderRadius: 20, padding: "6px 18px", fontSize: 13, fontWeight: 700 }}>
        Start →
      </div>
    </Link>
  );
}

export default function CompetitiveExamsPage() {
  return (
    <div style={S.page}>
      <Link to="/" style={S.back}>← Back to Home</Link>

      <div style={{ textAlign: "center", padding: "18px 0 32px" }}>
        <div style={{ fontSize: 30, fontWeight: 800, color: "#fff" }}>🎯 Competitive Examinations</div>
        <div style={{ fontSize: 14, color: "#94a3b8", marginTop: 8, maxWidth: 480, marginLeft: "auto", marginRight: "auto" }}>
          Pick an exam below to open its chapter-wise concept guides and practice questions.
        </div>
      </div>

      <div style={S.grid}>
        {EXAMS.map((exam) => (
          <ExamTile key={exam.title} exam={exam} />
        ))}
      </div>

      <div style={{ textAlign: "center", fontSize: 11.5, color: "#64748b", marginTop: 40 }}>
        More exams are added over time. Content is drafted for exam practice and NOT YET human-reviewed — verify against the official syllabus before relying on it.
      </div>
    </div>
  );
}
